

























import { Component, Prop, Vue, Watch } from 'vue-property-decorator';

import Icon, { IconEnum } from '@/shared/components/icon.component.vue';

export enum NumberPickerColor {
    Primary = 'number-picker--primary',
    Secondary = 'number-picker--secondary',
    Gold = 'number-picker--gold',
}

export enum NumberPickerSize {
    Standard = 'number-picker--standard-size',
    Small = 'number-picker--small-size',
}

@Component({
    components: {
        Icon,
    },
})
export default class NumberPicker extends Vue {
  @Prop({ default: 0 }) private initialNumber!: number;
  @Prop({ default: false }) private disabled !: boolean;
  @Prop({ default: NumberPickerColor.Primary }) private pickerColor !: NumberPickerColor;
  @Prop({ default: NumberPickerSize.Standard }) private pickerSize !: NumberPickerSize;
  @Prop({ default: 10 }) private maxNumber!: number;


  private iconEnum = IconEnum;
  private currentValue = this.initialNumber;


  @Watch('initialNumber')
  private watchInitialNumber(newVal: number, oldVal: number) {
      this.currentValue = newVal;
  }


  get hasValue() {
      return this.currentValue !== 0;
  }

  get isMinValue() {
      return this.currentValue === 0;
  }

  get isMaxValue() {
      return this.currentValue === this.maxNumber;
  }


  private substract() {
      if (!this.disabled && !this.isMinValue) {
          --this.currentValue;
          this.emitValue();
      }
  }

  private add() {
      if (!this.disabled && !this.isMaxValue) {
          ++this.currentValue;
          this.emitValue();
      }
  }

  private emitValue() {
      if (this.currentValue == 0) {
          this.$emit('input', 1);
          setTimeout(() => {
              this.$emit('input', 0);        
          }, 500);
      } else {
          this.$emit('input', this.currentValue);
      }
  }
}

